<template>
  <v-card flat tile>
    <v-card-title> 调整字体大小： </v-card-title>

    <v-sheet class="d-flex align-center pa-5">
      <v-spacer></v-spacer>
      <v-btn
        :disabled="fontSize <= 12"
        fab
        dark
        small
        color="primary"
        @click="decreaseFontSize"
      >
        <v-icon dark> mdi-minus </v-icon>
      </v-btn>

      <div class="ml-5 mr-5">
        <h1>{{ fontSize }}px</h1>
      </div>

      <v-btn
        :disabled="fontSize >= 22"
        fab
        dark
        small
        color="primary"
        @click="increaseFontSize"
      >
        <v-icon dark> mdi-plus </v-icon>
      </v-btn>

      <v-spacer></v-spacer>
    </v-sheet>
  </v-card>
</template>

<script>
export default {
  computed: {
    fontSize() {
      return this.$store.state.fontSize || 16;
    },
  },
  methods: {
    increaseFontSize() {
      if (this.fontSize >= 22)
        return this.$message.warning("最大设置为24号字体");
      this.$store.dispatch("changeFontSize", this.fontSize + 1);
    },
    decreaseFontSize() {
      if (this.fontSize <= 12)
        return this.$message.warning("最小设置为12号字体");
      this.$store.dispatch("changeFontSize", this.fontSize - 1);
    },
  },
};
</script>

<style></style>
